import type {
  LabelMap,
  SeverityMap,
  StatusSeverity
} from '@/components/atoms/badges/twn-status-indicator/TwnStatusIndicator.types'

export const resolveStatusLabel = (status: string, labelMap: LabelMap): string => labelMap[status] ?? status

export const resolveStatusSeverity = (
  status: string,
  severityMap: SeverityMap,
  fallback: StatusSeverity = 'contrast'
): StatusSeverity => severityMap[status] ?? severityMap['FALLBACK'] ?? fallback
